import type { Template } from "@/types";

export const LA_07_H7_V0: Template[] = [
    {
        id: "la-07-h7v0-01",
        name: "LA 01 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_01.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 78, y: 84, width: 256, height: 178, rotation: 0, imageRotation: 0 },
            { id: "2", x: 78, y: 270, width: 256, height: 178, rotation: 0, imageRotation: 0 },
            { id: "3", x: 342, y: 84, width: 256, height: 178, rotation: 0, imageRotation: 0 },
            { id: "4", x: 342, y: 270, width: 256, height: 178, rotation: 0, imageRotation: 0 },
            { id: "5", x: 793, y: 51, width: 217, height: 139, rotation: 0, imageRotation: 0 },
            { id: "6", x: 793, y: 198, width: 441, height: 285, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 51, width: 217, height: 139, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-02",
        name: "LA 02 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_02.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 39, y: 57, width: 600, height: 418, rotation: 0, imageRotation: 0 },
            { id: "2", x: 801, y: 57, width: 209, height: 134, rotation: 0, imageRotation: 0 },
            { id: "3", x: 801, y: 199, width: 209, height: 134, rotation: 0, imageRotation: 0 },
            { id: "4", x: 801, y: 342, width: 209, height: 133, rotation: 0, imageRotation: 0 },
            { id: "5", x: 1018, y: 57, width: 209, height: 134, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1018, y: 199, width: 209, height: 134, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1018, y: 342, width: 209, height: 133, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-03",
        name: "LA 03 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_03.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 93, y: 53, width: 487, height: 301, rotation: 0, imageRotation: 0 },
            { id: "2", x: 93, y: 362, width: 157, height: 118, rotation: 0, imageRotation: 0 },
            { id: "3", x: 258, y: 362, width: 157, height: 118, rotation: 0, imageRotation: 0 },
            { id: "4", x: 423, y: 362, width: 157, height: 118, rotation: 0, imageRotation: 0 },
            { id: "5", x: 774, y: 53, width: 486, height: 264, rotation: 0, imageRotation: 0 },
            { id: "6", x: 774, y: 325, width: 239, height: 155, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1021, y: 325, width: 239, height: 155, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-04",
        name: "LA 04 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_04.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 56, y: 70, width: 565, height: 393, rotation: 0, imageRotation: 0 },
            { id: "2", x: 732, y: 70, width: 184, height: 126, rotation: 0, imageRotation: 0 },
            { id: "3", x: 732, y: 203, width: 184, height: 126, rotation: 0, imageRotation: 0 },
            { id: "4", x: 732, y: 337, width: 184, height: 126, rotation: 0, imageRotation: 0 },
            { id: "5", x: 924, y: 70, width: 183, height: 126, rotation: 0, imageRotation: 0 },
            { id: "6", x: 1115, y: 70, width: 183, height: 126, rotation: 0, imageRotation: 0 },
            { id: "7", x: 924, y: 203, width: 374, height: 259, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-05",
        name: "LA 05 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_05.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 244, y: 54, width: 283, height: 208, rotation: 0, imageRotation: 0 },
            { id: "2", x: 535, y: 54, width: 283, height: 208, rotation: 0, imageRotation: 0 },
            { id: "3", x: 826, y: 54, width: 282, height: 208, rotation: 0, imageRotation: 0 },
            { id: "4", x: 100, y: 269, width: 282, height: 208, rotation: 0, imageRotation: 0 },
            { id: "5", x: 390, y: 269, width: 282, height: 208, rotation: 0, imageRotation: 0 },
            { id: "6", x: 680, y: 269, width: 282, height: 208, rotation: 0, imageRotation: 0 },
            { id: "7", x: 970, y: 269, width: 281, height: 208, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-06",
        name: "LA 06 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_06.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 108, y: 38, width: 278, height: 191, rotation: 0, imageRotation: 0 },
            { id: "2", x: 394, y: 38, width: 278, height: 191, rotation: 0, imageRotation: 0 },
            { id: "3", x: 680, y: 38, width: 278, height: 191, rotation: 0, imageRotation: 0 },
            { id: "4", x: 966, y: 38, width: 277, height: 191, rotation: 0, imageRotation: 0 },
            { id: "5", x: 108, y: 238, width: 373, height: 256, rotation: 0, imageRotation: 0 },
            { id: "6", x: 489, y: 238, width: 373, height: 256, rotation: 0, imageRotation: 0 },
            { id: "7", x: 870, y: 238, width: 373, height: 256, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-07",
        name: "LA 07 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_07.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 50, y: 44, width: 203, height: 142, rotation: 0, imageRotation: 0 },
            { id: "2", x: 50, y: 194, width: 203, height: 142, rotation: 0, imageRotation: 0 },
            { id: "3", x: 50, y: 345, width: 203, height: 141, rotation: 0, imageRotation: 0 },
            { id: "4", x: 261, y: 345, width: 202, height: 141, rotation: 0, imageRotation: 0 },
            { id: "5", x: 471, y: 345, width: 202, height: 141, rotation: 0, imageRotation: 0 },
            { id: "6", x: 261, y: 44, width: 412, height: 292, rotation: 0, imageRotation: 0 },
            { id: "7", x: 681, y: 44, width: 622, height: 442, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-08",
        name: "LA 08 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_08.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 49, y: 44, width: 622, height: 442, rotation: 0, imageRotation: 0 },
            { id: "2", x: 679, y: 44, width: 203, height: 142, rotation: 0, imageRotation: 0 },
            { id: "3", x: 679, y: 194, width: 203, height: 142, rotation: 0, imageRotation: 0 },
            { id: "4", x: 679, y: 345, width: 203, height: 141, rotation: 0, imageRotation: 0 },
            { id: "5", x: 890, y: 345, width: 202, height: 141, rotation: 0, imageRotation: 0 },
            { id: "6", x: 890, y: 44, width: 412, height: 292, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1100, y: 345, width: 202, height: 141, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-09",
        name: "LA 09 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_09.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 71, y: 76, width: 354, height: 251, rotation: 0, imageRotation: 0 },
            { id: "2", x: 433, y: 76, width: 173, height: 122, rotation: 0, imageRotation: 0 },
            { id: "3", x: 433, y: 205, width: 173, height: 122, rotation: 0, imageRotation: 0 },
            { id: "4", x: 71, y: 335, width: 173, height: 121, rotation: 0, imageRotation: 0 },
            { id: "5", x: 252, y: 335, width: 173, height: 121, rotation: 0, imageRotation: 0 },
            { id: "6", x: 433, y: 335, width: 173, height: 121, rotation: 0, imageRotation: 0 },
            { id: "7", x: 676, y: 0, width: 676, height: 531, rotation: 0, imageRotation: 0 }
        ],
    },

    {
        id: "la-07-h7v0-10",
        name: "LA 10 - H7V0",
        albumType: "LA",
        thumbnail: "/thumbnails/LA/AR_2.50/la-07-h7_v0_10.png",
        size: [1352, 531],
        style: {},
        slots: [
            { id: "1", x: 0, y: 0, width: 676, height: 531, rotation: 0, imageRotation: 0 },
            { id: "2", x: 747, y: 76, width: 354, height: 251, rotation: 0, imageRotation: 0 },
            { id: "3", x: 1109, y: 76, width: 173, height: 122, rotation: 0, imageRotation: 0 },
            { id: "4", x: 1109, y: 205, width: 173, height: 122, rotation: 0, imageRotation: 0 },
            { id: "5", x: 747, y: 335, width: 173, height: 121, rotation: 0, imageRotation: 0 },
            { id: "6", x: 928, y: 335, width: 173, height: 121, rotation: 0, imageRotation: 0 },
            { id: "7", x: 1109, y: 335, width: 173, height: 121, rotation: 0, imageRotation: 0 }
        ],
    }
];